var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NprogressContainer'),(!_vm.isSharedTripRoute)?_c('Layout'):_c('router-view'),_c('v-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }